module.exports = __webpack_public_path__ + "img/logistik.81a27d97.svg";